export default __webpack_public_path__ + "static/media/004.9a99c496.jpg";